<template>
  <div class="content-main">
    <div class="page-complain-edit" v-if="!submit_result">
      <div class="part-title">退款原因</div>
      <textarea id="complain-content" rows="8" cols="20" maxlength="200" placeholder="请填写你申请退款的原因" v-model="complain.describe"></textarea>

      <div class="btn-submit" id="btn-submit" @click="confirmSubmit()">提交</div>
    </div>

    <div class="refund-rules" v-if="!submit_result">
      <div class="rules-title"><strong>退款规则：<span class="remark">（可退款金额 = 付款金额 ➖ 已用留言条数）</span></strong></div>
      <div class="refund-rule">● <strong>单条留言：</strong>包含1条留言额度，留言提交后权益已使用完毕，不可退款</div>
      <div class="refund-rule">● <strong>6元套餐：</strong>包含6条基础留言+4条附赠留言，总计10条留言额度。使用顺序为：先消耗基础留言，后消耗附赠留言。基础留言消耗完前，若已消耗N条，可退款6-N元；基础留言消耗完后，不可退款</div>
      <div class="refund-rule">● <strong>9元套餐：</strong>包含9条基础留言+11条附赠留言，总计20条留言额度。使用顺序为：先消耗基础留言，后消耗附赠留言。基础留言消耗完前，若已消耗N条，可退款9-N元；基础留言消耗完后，不可退款</div>
      <div class="refund-rule">● <strong>19元套餐：</strong>包含19条基础留言+31条附赠留言，总计50条留言额度。使用顺序为：先消耗基础留言，后消耗附赠留言。基础留言消耗完前，若已消耗N条，可退款19-N元；基础留言消耗完后，不可退款</div>
    </div>

    <div class="page-success" v-if="submit_result">
      <img class="img-success" src="https://static.huiyiji520.com/submit-success-210916.png">
      <div class="hint hint1">申请提交成功！</div>
      <div class="hint hint2">我们会在3个工作日内处理</div>
      <!-- <div class="hint hint2">我们会在3个工作日内审核</div> -->
      <!-- <div class="hint hint2">并处理相关内容</div> -->
      <div class="btn-back" @click="goIndex()">返回首页</div>
    </div>

  </div>
</template>

<script>
// import wx from 'weixin-jsapi'
// import wx from 'weixin-js-sdk'
import wx from 'weixin-js-sdk'
import { Toast, Dialog } from 'vant'

export default{
  data(){
    return {
      complain: {
        describe: ""
      },
      submit_result: false,
      loading: false
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    confirmSubmit(){
      let _this = this
      Dialog.confirm({
        title: '提示',
        message: '是否确认提交退款申请'
      }).then(() => {
        // on confirm
        _this.submitComplain()
      }).catch(() => {
        // on cancel
      });
    },
    submitComplain(){
      let describe = this.abbrevText(this.complain.describe, 200)
      if(!describe){
        Toast('请填写反馈描述')
        return
      }else if(this.complain.describe.trim().length < 10){
        Toast('反馈描述不能少于10个字')
        return
      }else if(this.loading){
        return
      }else{
        this.loading = true
        let openid = this.$store.state.userinfo.openid
        this.$api.post('/complain/create_garden_refund_apply_by_user', {openid: openid, describe: describe, id: this.$route.params.id}, res => {
          if(res.code == 200){
            this.submit_result = true
            this.loading = false
          }
        })
      }
    },
    goIndex(){
      this.$router.replace('/message_choose')
    },

    abbrevText(text, len){
      if(text.length <= len){
        return text.trim()
      }else{
        return text.trim().slice(0, len) + '...'
      }
    },
    wxConfigInit(){
      this.$api.get('/shanzhadao/get_wx_js_config_shanzhadao', {url: window.location.href}, res => {
        if(res.code == 200 && res.config){
          // alert('config: ' +JSON.stringify(res.config))
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.config.app_id, // 必填，公众号的唯一标识
            timestamp: res.config.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.config.noncestr, // 必填，生成签名的随机串
            signature: res.config.signature,// 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
          });

          let share_nickname = this.$store.state.userinfo.nickname
          let share_title = `${share_nickname}给你写了一条留言～`
          let share_desc = '这里有你的故事'
          let share_link = this.$store.state.siteDomain
          let share_img = this.$store.state.userinfo.headimg

          let openid = this.$store.state.userinfo.openid
          let site_code = this.$store.state.siteCode
          let _this = this
          //分享到朋友圈（即将废弃）
          wx.onMenuShareTimeline({
            title: share_title, // 分享标题
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_img, // 分享图标
            success: function () {
              // 用户点击了分享后执行的回调函数
              _this.$hawutil.reportShare(site_code, openid)
            }
          })
          //分享给朋友（即将废弃）
          wx.onMenuShareAppMessage({
            title: share_title, // 分享标题
            desc: share_desc, // 分享描述
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_img, // 分享图标
            type: '', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户点击了分享后执行的回调函数
              _this.$hawutil.reportShare(site_code, openid)
            }
          })
          // //分享给朋友
          // wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
          //   wx.updateAppMessageShareData({
          //     title: share_title, // 分享标题
          //     desc: share_desc, // 分享描述
          //     link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //     imgUrl: share_img, // 分享图标
          //     success: function () {
          //       // 设置成功
          //       // _this.$hawutil.reportShare(site_code, openid)
          //     }
          //   })
          // });
          //
          // //分享到朋友圈
          // wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
          //   wx.updateTimelineShareData({
          //     title: share_title, // 分享标题
          //     link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //     imgUrl: share_img, // 分享图标
          //     success: function () {
          //       // 设置成功
          //       // _this.$hawutil.reportShare(site_code, openid)
          //     }
          //   })
          // });

        }
      })
    }
  },
  mounted(){
    this.wxConfigInit()
  }
}
</script>

<style scoped>
.content-main{min-height:100%;}
.page-complain-edit{text-align:left;background-color:#f6f8f9;}
.part-title{color:#666;font-size:15px;padding:10px 12px;}
textarea{width:100%;padding:5px 15px;color:#333;font-size:15px;margin-bottom:15px;}
.btn-submit{background:#1aad19;color:white;font-size:18px;height:45px;line-height:45px;text-align:center;width:90%;border-radius:5px;margin:0px auto;}
textarea:focus,input:focus {outline:none;box-shadow:none;-webkit-appearance: none;}
input, textarea{border:none;outline:none;}
*::-webkit-input-placeholder {color: #969799;font-size:13px;}
*:-moz-placeholder {/* FF 4-18 */color: #969799;font-size:13px;}
*::-moz-placeholder {/* FF 19+ */color: #969799;font-size:13px;}
*:-ms-input-placeholder {/* IE 10+ */color: #969799;font-size:13px;}
.page-success{padding-top:100px;}
.img-success{width:80px;height:80px;margin-bottom:30px;visibility:visible;}
.page-success .hint{font-size:17px;}
.page-success .hint1{color:#333;margin-bottom:15px;}
.page-success .hint2{color:#333;margin-bottom:5px;}
.page-success .hint3{color:#dd4b39;}
.btn-back{
  background:#4caf50;color:#fff;font-size:15px;height:45px;line-height:45px;
  margin:0 auto;margin-top:30px;width:70%;border-radius:2px;
}

.refund-rules{color:#444;text-align:left;padding:20px;font-size:13px;}
.refund-rules .remark{font-size:12px;margin-left:5px;font-weight:bold;}
.refund-rules .rules-title{margin-bottom:5px;}
.refund-rules .refund-rule{margin-bottom:8px;}
</style>
